import { Card, Col, Row, Spin, Typography } from 'antd'
import mymatpic from '$assets/img/mymatpic.png'
import { useQuery } from '@tanstack/react-query'
import {
  fetchOperatorAdditiveMaterialsKpiCount,
  fetchServiceProviderMaterialsKpiCount,
} from '$api/evoAPIs'

const { Title } = Typography

const TopKpiCard = ({ t }) => {
  const {
    data: serviceProviderMaterialsKpiCount,
    isLoading: isLoadingServiceProviderKpis,
  } = useQuery({
    queryKey: ['ServiceProviderMaterialsKpiCount'],
    queryFn: fetchServiceProviderMaterialsKpiCount,
  })

  const {
    data: operatorAdditiveMaterialsKpiCount,
    isLoading: isLoadingOperatorAdditiveKpis,
  } = useQuery({
    queryKey: ['OperatorAdditiveMaterialsKpiCount'],
    queryFn: fetchOperatorAdditiveMaterialsKpiCount,
  })

  return (
    <Row
      className="myevocard"
      gutter={[24, 24]}
      style={{ marginBottom: '24px' }}
    >
      <Col
        xs={24}
        sm={6}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={mymatpic} width="135px" alt="My Materials Illustration" />
      </Col>
      <Col xs={24} sm={6}>
        <Card>
          <Typography.Text>
            {t(
              'service_provider_additive_materials.kpi_unmapped_service_provider_additive_materials',
            )}
          </Typography.Text>
          <Title level={1}>
            {isLoadingServiceProviderKpis ? (
              <Spin />
            ) : (
              serviceProviderMaterialsKpiCount?.unmapped_materials || 0
            )}
          </Title>
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card>
          <Typography.Text>
            {t(
              'service_provider_additive_materials.kpi_service_provider_additive_materials',
            )}
          </Typography.Text>
          <Title level={1}>
            {isLoadingServiceProviderKpis ? (
              <Spin />
            ) : (
              serviceProviderMaterialsKpiCount?.total_service_provider_materials ||
              0
            )}
          </Title>
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card>
          <Typography.Text>
            {t('operator_additive_materials.kpi_operator_additive_materials')}
          </Typography.Text>
          <Title level={1}>
            {isLoadingOperatorAdditiveKpis ? (
              <Spin />
            ) : (
              operatorAdditiveMaterialsKpiCount?.total_operator_additive_materials ||
              0
            )}
          </Title>
        </Card>
      </Col>
    </Row>
  )
}

export default TopKpiCard
